import React, { useEffect, useMemo, useState } from 'react'
import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, CircularProgress, Typography, Stack, Link, TablePagination, Button, Box,
} from '@mui/material'

import OpenInNewIcon from '@mui/icons-material/OpenInNew'

interface Props {
  subscriber: any
}

export const InvoicesTable: React.FC<Props> = ({ subscriber }) => {
  const invoices = subscriber?.invoices ?? []
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const rowsPerPage = 5

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number) => {
    setPage(newPage)
  }
  const sortedInvoices = [...invoices].sort((a, b) => {
    return new Date(b.paidOn || 0).getTime() - new Date(a.paidOn || 0).getTime()
  })

  const totalPayments = sortedInvoices.filter(inv => inv.paidOn).length

  const paginatedInvoices = useMemo(() => {
    const start = page * rowsPerPage
    const end = start + rowsPerPage

    return sortedInvoices.slice(start, end)
  }, [page, rowsPerPage, sortedInvoices])

  useEffect(() => {
    if (Array.isArray(invoices)) {
      setLoading(false)
    }
  }, [invoices])

  if (loading) return <CircularProgress />
  if (!invoices.length) return <></>

  const formatDateTime = (dateStr: string) => {
    const d = new Date(dateStr)
    const pad = (n: number) => n.toString().padStart(2, '0')

    const day = pad(d.getDate())
    const month = pad(d.getMonth() + 1)
    const year = d.getFullYear()

    const hours = pad(d.getHours())
    const minutes = pad(d.getMinutes())
    const seconds = pad(d.getSeconds())

    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
  }

  return (
    <Stack>
      <Typography variant="h6" gutterBottom>
        Total payment count:{' '}
        <span style={{ color: 'red' }}>{totalPayments}</span>
      </Typography>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center"><strong>ID</strong></TableCell>
                <TableCell align="center"><strong>Description</strong></TableCell>
                <TableCell align="center"><strong>Status</strong></TableCell>
                <TableCell align="center"><strong>Price</strong></TableCell>
                <TableCell align="center"><strong>Paid On</strong></TableCell>
                <TableCell align="center"><strong>Payment Details</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedInvoices.map((inv, index) => (
                <TableRow key={inv.id}
                  sx={{ backgroundColor: index % 2 === 0 ? '#f5f7ff' : 'white' }} >
                  <TableCell align="center">{inv.id}</TableCell>
                  <TableCell align="center">{inv.description}</TableCell>
                  <TableCell align="center">{inv.status}</TableCell>
                  <TableCell align="center">${inv.price}</TableCell>
                  <TableCell align="center"> {inv.paidOn ? formatDateTime(inv.paidOn) : '—'}
                  </TableCell>
                  <TableCell align="center">
                    <Button variant="contained" color="primary"
                      style={{ width: 30, height: 30, minWidth: 0, borderRadius: '50%', padding: 0 }} onClick={() => window.open(inv.invoiceLink, '_blank', 'noopener,noreferrer')}>
                      <OpenInNewIcon style={{ width: 16, height: 16 }} /> </Button>
                  </TableCell>
                </TableRow>))
              }
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination component="div" count={sortedInvoices.length} page={page} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} rowsPerPageOptions={[]} />
      </Paper>
    </Stack>

  )
}
